import { computed, reactive } from 'vue';
import axios from 'axios';

const httpInstance = axios.create();

const state = reactive({
  banks: {
    value: null,
    options: []
  }
});

export default function useBank() {
  const loadBanks = async () => {
    if (!state.banks.options.length) {
      try {
        const {
          data: { banks }
        } = await httpInstance.get('get/api/bankLink/banks');
        const collectBanks = [];

        const bankEntries = Object.entries(banks);
        let isFirst = true;
        for await (const [bankId, bankData] of bankEntries) {
          collectBanks.push({
            value: bankId,
            label: bankData.name,
            type: bankData.type || null,
            image: getBankImage(bankData.sys_tag)
          });
          if (isFirst) {
            state.banks.value = bankId;
          }
          isFirst = false;
        }

        state.banks.options = collectBanks;
      } catch (error) {
        console.error(error);
      }
    }
  };

  const getFilteredBanks = () => {
    return computed(() => {
      return state.banks;
    }).value;
  };

  const getBankImage = sysTag => {
    return window.shop.bank.logoByKey[sysTag] || '';
  };

  const getSelectedBankKey = () => {
    return state.banks.value || null;
  };

  return {
    getFilteredBanks,
    loadBanks,
    getSelectedBankKey
  };
}
